import {
  Profile as BProfile,
} from '@/services/types/profile-api-service';
import {
  Profile as FProfile,
} from '@/transformers/profile/types';
import {
  Transformer,
} from '@/transformers/Transformer';


type Send = void;
type TSend = void;
type Fetch = BProfile;
type TFetch = FProfile;

export class ProfileTransformer extends Transformer<Send, TSend, Fetch, TFetch> {
  public send(): TSend {
    //
  }

  public fetch(data: Fetch): TFetch {
    return data;
  }
}
